export default __webpack_public_path__ + "static/media/lingerie-3.cfbac403.jpg";